import type { Filter } from '@repo/api-codegen';
import { isNil } from 'lodash-es';
import {
	DataQualityClassification,
	DataQualityClassificationBounds,
} from '../enums/dataQualityClassification';

export function formatScore(score: number) {
	/* Score should be rounded down for consistency of formatting */
	return Math.floor(score);
}

export function getScoreClassification(
	score: number | undefined
): DataQualityClassification {
	if (isNil(score) || score < 0 || score > 100) {
		return DataQualityClassification.UNAVAILABLE;
	}

	const rounded = formatScore(score || 0);
	if (rounded < DataQualityClassificationBounds.MODERATE) {
		return DataQualityClassification.POOR;
	}

	if (rounded < DataQualityClassificationBounds.GOOD) {
		return DataQualityClassification.MODERATE;
	}

	if (rounded < DataQualityClassificationBounds.GREAT) {
		return DataQualityClassification.GOOD;
	}

	return DataQualityClassification.GREAT;
}

export function getScoreClassificationFromFilter(
	filter: Filter
): DataQualityClassification {
	if (typeof filter.value !== 'number') {
		return DataQualityClassification.UNAVAILABLE;
	}

	if (
		filter.operator === 'gte' &&
		filter.value === DataQualityClassificationBounds.GREAT
	) {
		return DataQualityClassification.GREAT;
	}

	if (
		(filter.operator === 'gte' &&
			filter.value === DataQualityClassificationBounds.GOOD) ||
		(filter.operator === 'lt' &&
			filter.value === DataQualityClassificationBounds.GREAT)
	) {
		return DataQualityClassification.GOOD;
	}

	if (
		(filter.operator === 'gte' &&
			filter.value === DataQualityClassificationBounds.MODERATE) ||
		(filter.operator === 'lt' &&
			filter.value === DataQualityClassificationBounds.GOOD)
	) {
		return DataQualityClassification.MODERATE;
	}

	if (
		filter.operator === 'lt' &&
		filter.value === DataQualityClassificationBounds.MODERATE
	) {
		return DataQualityClassification.POOR;
	}

	return DataQualityClassification.UNAVAILABLE;
}
